import React                   from 'react'

export default (props) => {
  return (
    <header>
      <nav className="navbar navbar-expand-md navbar-light fixed-top">
        <div className="login-logo">
          <img src={require('../../../../assets/images/logo-horizontal.png')} className="img-fluid" alt="logo" />
        </div>
      </nav>
    </header>
  )
}